<div class="workSpace">
    <!-- CONTENIDO VERSION MOVILES -->
    <div class="w3-center tablero fondoCuestionario">
        <!-- FORMULARIO INICIAL -->
        @if (estado === 1) {
            @if(!catalogosCargados){
                <div  class="spinner-overlay">
                    <div class="spinner-css"></div> 
                </div>
            }
        <div class="formulario w3-center">
            <div class="conteFormulario">
                <div style="width: 95%;">
                    <b>{{'cues.cuestionariov2.tituloCuest' | translate}}</b>
                    <br>
                    {{'cues.cuestionariov2.textoCuest' | translate}}
                </div>
                <div class="conteCampo">
                    <!--Campos 100% dinámicos: solo los catálogos que trae la institución-->
                    @for (campo of campos; track campo.key) {
                        <div class="w3-row conteInput">
                            <div class="w3-col texto">
                                <div class="etiquetas">{{ campo.label }}</div>
                            </div>
                            <div class="contentSelect inputSelect w3-col" (click)="openModal(campo.opciones, campo.key)">
                                {{ info.controls[campo.key].value }}</div>
                        </div>
                    }
                    <div style="display: flex; justify-content: center; margin-top: 2vh;">
                        <re-captcha #captchaRef (resolved)="onCaptchaResolved($event)"
                            siteKey="6LdTXOkrAAAAAHQOUDNJjzt739NFZppxYI80luDp"></re-captcha>
                    </div>
                </div>
                <div class="w3-center botonesModales" style="padding-top: 2vh;" [ngClass]="continuar()">
                    <button mat-flat-button color="success" style="height: 3vh;"
                        (click)="guardarInfo()">{{'cues.cuestionariov2.continuar' | translate}}</button>
                </div>
            </div>
        </div>
        }
        @if (estado === 2) {
        <div class="formulario w3-center ">
            <div class="conteFormulario">
                <div class="tituloComponentes">
                    <h2>{{dataCuestionario.name}}</h2>
                </div>
                <div class="listaComponentes">
                    @for (componente of dataCuestionario.elementos; let i = $index; track componente) {
                    <div class="componente"
                        [class.componente-disabled]="!puedeSeleccionarComponente(i)"
                        (click)="puedeSeleccionarComponente(i) && verDescripcionCompleta(componente)">
                        <span *ngIf="estaComponenteContestado(i)" class="check-componente">
                            <mat-icon>check_circle</mat-icon>
                        </span>
                        <h3>{{componente.name}}</h3>
                        <p>{{componente.description.length > 250 ? (componente.description | slice:0:250) + '...' :
                            componente.description}}</p>
                    </div>
                    }
                </div>
                <div class="w3-center botonesModales" style="padding-top: 2vh;">
                    <button mat-flat-button color="success" (click)="terminar()"
                    [disabled]="componentesContestados() < dataCuestionario.elementos.length"
                    [ngClass]="{'disabled': componentesContestados() < dataCuestionario.elementos.length}">
                    Enviar</button>
                </div>
            </div>
            <div class="barra-progreso-contenedor">
                <div class="barra-progreso">
                    <div class="barra-progreso-inner"
                        [style.width.%]="(componentesContestados() / dataCuestionario.elementos.length) * 100">
                    </div>
                </div>
                <div class="barra-progreso-texto">
                    {{componentesContestados()}} / {{dataCuestionario.elementos.length}} {{'cues.cuestionariov2.componentesContestados' | translate}}
                </div>
            </div>
        </div>
        }

        @if (estado === 3) {
        <div class="formulario w3-center">
            <div class="conteFormulario">
                <div class="tituloComponentes">
                    <h2 style="color: #ff7f50;">{{componenteSeleccionado?.name}}</h2>
                </div>
                <div class="descripcionCompleta">
                    <p>{{componenteSeleccionado?.description}}</p>
                </div>
                <div class="botones" style="display: flex; margin-top: 20px; gap: 8vh;">
                    <button class="btnAnterior" (click)="estado = 2">{{'cues.cuestionariov2.regresar' | translate}}</button>
                    <button class="btnSiguiente"
                        (click)="redirigirCuestionario(componenteSeleccionado)">{{'cues.cuestionariov2.comenzar' | translate}}</button>
                </div>
            </div>
        </div>
        }

        <!-- CUESTIONARIO -->
        @if (estado === 4) {
        <div class="carruselPreguntas">
            <div class="pregunta">
                <div
                    style="display: flex; align-items: start; justify-self: unset; margin-top: -15px; margin-bottom: 28px;">
                    <button class="btnRegresar" (click)="estado = 2">
                        <mat-icon>arrow_back</mat-icon>
                        <p>{{'cues.cuestionariov2.regresar' | translate}}</p>
                    </button>
                </div>
                <h3>
                {{ dataTarjetas[slideIndex]?.componente || titCmp }}
                </h3>
                <div [ngClass]="sinResponder(dataTarjetas[slideIndex]?.descripcion)" style="padding: 5px;">
                    <div style="display: flex; align-items: baseline;">
                        <p>{{dataTarjetas[slideIndex]?.descripcion.order}}.
                            {{dataTarjetas[slideIndex]?.descripcion.descripcion}}
                            @if (dataTarjetas[slideIndex]?.descripcion.requerida) {
                            <span style="color: red; padding-left: 8px; font-size: large;"
                                matTooltip="{{'cues.cuestionarios.requerido' | translate}}">*</span>
                            }
                        </p>
                    </div>
                    <div class="opciones">
                        @for (respuesta of dataTarjetas[slideIndex]?.descripcion.respuestas; track respuesta) {
                        <label class="opcion">
                            <input type="radio" name="respuesta-{{dataTarjetas[slideIndex]?.id}}"
                                value="{{respuesta.id}}" [(ngModel)]="dataTarjetas[slideIndex].descripcion.selected"
                                (ngModelChange)="hojaRespuestas(dataTarjetas[slideIndex]?.id, $event)">
                            {{respuesta.descrip}}
                        </label>
                        }
                    </div>
                </div>
                <div class="botones">
                    <button class="btnAnterior" (click)="plusDivs(-1)" [disabled]="slideIndex === 0"
                        [ngClass]="{'disabled': slideIndex === 0}">
                        <mat-icon>arrow_back</mat-icon> {{'cues.cuestionariov2.anterior'|translate}}
                    </button>
                    <button class="btnSiguiente" (click)="plusDivs(1)"
                        [disabled]="!puedeAvanzar()"
                        [ngClass]="{'disabled': !puedeAvanzar()}">
                        {{'cues.cuestionariov2.siguiente'|translate}} <mat-icon>arrow_forward</mat-icon>
                    </button>
                </div>
            </div>
            <div class="barra-progreso-contenedor">
                <div class="barra-progreso">
                    <div class="barra-progreso-inner" [style.width.%]="(preguntasContestadas() / dataTarjetas.length) * 100">
                    </div>
                </div>
                <div class="barra-progreso-texto">
                    {{preguntasContestadas()}} / {{dataTarjetas.length}} {{'cues.cuestionariov2.preguntasContestadas'|translate}}
                </div>
            </div>
        </div>
        }
        <!-- MENSAJE FINAL -->
        @if (estado === 5) {
        <div class="terminado formulario">
            <div class="txtTerminado" style="margin: 5vh 0;">
                <b>{{'cues.cuestionariov2.tituloFinal' | translate}}</b>
                <br><br>
                {{'cues.cuestionariov2.textoFinal1' | translate}}
                <br>
                {{'cues.cuestionariov2.textoFinal2' | translate}}
                <br>
                {{'cues.cuestionariov2.textoFinal3' | translate}}
                <br><br>
                <b>{{'cues.cuestionariov2.textoFinal4' | translate}}</b>
            </div>
        </div>
        }

        <!-- ASIGNACIÓN EXPIRADA -->
        @if (estado === 6) {
        <div class="terminado formulario">
            <div class="txtTerminado" style="margin: 5vh 0; display: flex; flex-direction: column; align-items: center; gap: 2vh;">
                <mat-icon style="font-size: 60px; width: 60px; height: 60px; color: #ff6b00;">
                    schedule
                </mat-icon>
                <b style="font-size: 20pt; color: #ff6b00;">
                    {{'cues.cuestionariov2.asignacionExpirada' | translate}}
                </b>
                <p style="font-size: 14pt; text-align: center; margin-top: 2vh;">
                    {{'cues.cuestionariov2.textoAsignacionExpirada' | translate}}
                </p>
            </div>
        </div>
        }

        <!-- ENLACE NO VÁLIDO (no existe asignación para ese hash/cuestionario/token) -->
        @if (estado === 7) {
        <div class="terminado formulario">
            <div class="txtTerminado" style="margin: 5vh 0; display: flex; flex-direction: column; align-items: center; gap: 2vh;">
                <mat-icon style="font-size: 60px; width: 60px; height: 60px; color: #ff6b00;">
                    link_off
                </mat-icon>
                <b style="font-size: 20pt; color: #ff6b00;">
                    {{'cues.cuestionariov2.enlaceInvalido' | translate}}
                </b>
                <p style="font-size: 14pt; text-align: center; margin-top: 2vh;">
                    {{'cues.cuestionariov2.textoEnlaceInvalido' | translate}}
                </p>
            </div>
        </div>
        }
    </div>
</div>

<div id="ampliar" class="modal" (click)="clickFuera($event,'ampliar')">
    <div class="modalContent modalInput">
        <div class="w3-card-4 w3-white" style="border-radius: 10px;">
            <mat-list role="list">
                @for (i of mostrarCatalogo; track i) {
                <mat-list-item role="listitem" style="cursor: pointer;" (click)="guardarCampo(i)">{{i}}</mat-list-item>
                <mat-divider></mat-divider>
                }
            </mat-list>
        </div>
    </div>
</div>